import { NgModule } from '@angular/core';
import { RouterModule, Routes, PreloadAllModules } from '@angular/router';
import { Shell } from '../core/services/shell.service';
import { AdminShell } from '../core/services/admin-shell.service';

const routes: Routes = [
  {
    path: 'login',
    loadChildren: () =>
      import('../modules/authentication/authentication.module').then((m) => {
        return m.AuthenticationModule;
      }),
  },
  {
    path: '',
    loadChildren: () =>
      import('../modules/authentication/authentication.module').then((m) => {
        return m.AuthenticationModule;
      }),
  },

  Shell.childRoutes([
    {
      path: 'user',
      loadChildren: () =>
        import('../modules/user/user.module').then((m) => {
          return m.UserModule;
        }),
    },
    {
      path: 'dashboard',
      loadChildren: () =>
        import('../modules/dashboard/dashboard.module').then((m) => {
          return m.DashboardModule;
        }),
    },
    {
      path: 'administrator',
      loadChildren: () =>
        import('../modules/administrator/administrator.module').then((m) => {
          return m.AdministratorModule;
        }),
    },
    {
      path: 'expense',
      loadChildren: () =>
        import('../modules/expense/expense.module').then((m) => {
          return m.ExpenseModule;
        }),
    },
    // {
    //   path: 'report',
    //   loadChildren: () =>
    //     import('../modules/expense/expense.module').then((m) => {
    //       return m.ExpenseModule;
    //     }),
    // },
    {
      path: 'approval',
      loadChildren: () =>
        import('../modules/expense/expense.module').then((m) => {
          return m.ExpenseModule;
        }),
    },
    {
      path: 'transcation',
      loadChildren: () =>
        import('../modules/transcation/transcation.module').then((m) => {
          return m.TranscationModule;
        }),
    },
    {
      path: 'settlement',
      loadChildren: () =>
        import('../modules/settlement/settlement.module').then((m) => {
          return m.SettlementModule;
        }),
    },
    {
      path: 'settings',
      loadChildren: () =>
        import('../modules/settings/settings.module').then((m) => {
          return m.SettingsModule;
        }),
    },
    {
      path: 'matrix',
      loadChildren: () =>
        import('../modules/approval-matrix//approval-matrix.module').then(
          (m) => {
            return m.ApprovalMatrixModule;
          }
        ),
    },
    {
      path: 'matrix',
      loadChildren: () =>
        import('../modules/approval-matrix//approval-matrix.module').then(
          (m) => {
            return m.ApprovalMatrixModule;
          }
        ),
    },
    {
      path: 'vendors',
      loadChildren: () =>
        import('../modules/vendor/vendor.module').then((m) => m.VendorModule),
    },
    {
      path: 'invoices-dashboard',
      loadChildren: () =>
        import('../modules/invoice/invoice.module').then((m) => m.InvoiceModule),
    },
    {
      path: 'payouts-dashboard',
      loadChildren: () =>
        import('../modules/payouts/payouts.module').then((m) => m.PayoutsModule),
    },
    {
      path: 'ap-approval',
      loadChildren: () =>
        import('../modules/ap-approval/ap-approval.module').then((m) => m.ApApprovalModule),
    },
    {
      path: 'credit-notes',
      loadChildren: () =>
        import('../modules/credit-note/credit-note.module').then((m) => m.CreditNoteModule),
    },
    {
      path: 'trip',
      loadChildren: () =>
        import('../modules/trip/trip.module').then((m) => m.TripModule),
    },
    {
      path: 'credits-reversals',
      loadChildren: () =>
        import('../modules/credits-reversals/credits-reversals.module').then((m) => m.CreditsReversalsModule),
    },
  ]),

  AdminShell.childRoutes([
    {
      path: 'panel',
      loadChildren: () =>
        import('../modules/control-panel/control-panel.module').then((m) => {
          return m.ControlPanelModule;
        }),
    },
  ]),
  { path: '**', redirectTo: 'login', pathMatch: 'full' },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: false,
      initialNavigation: 'enabledBlocking', // Keep this crucial setting
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
